import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const AddOutletToUser = () => {
  const [getUsersData, setGetUsersData] = useState([]);
  const [getOutletsData, setGetOutletsData] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedOutlets, setSelectedOutlets] = useState([]);

  // Format outlets for react-select
  const outletOptions = getOutletsData.map((item) => ({
    value: item.Outlate_Id,
    label: item.Outlet_Name,
  }));

  // Fetch users and outlets
  const getUsers = async () => {
    try {
      const [outletResponse, userResponse] = await Promise.all([
        axios.get(`${process.env.REACT_APP_SERVER_API}outlates`),
        axios.get(`${process.env.REACT_APP_SERVER_API}users`)
      ]);
      setGetOutletsData(outletResponse.data);
      setGetUsersData(userResponse.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  // Submit selected outlets for user
  const upsertUserOutletData = async () => {
    if (!selectedUserId) {
      alert("Please select a user.");
      return;
    }
    if (selectedOutlets.length === 0) {
      alert("Please select at least one outlet.");
      return;
    }

    // Prepare data to send
    const outletData = selectedOutlets.map(outlet => ({
      outlate_id: outlet.value,
      Outlate_Name: outlet.label
    }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}addOutletToUserByUserId/${selectedUserId}`,
        outletData
      );
      alert("Outlets added successfully!");


      
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Error adding outlets.");
    }
  };

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-12'>
          <select
            className="form-select"
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
          >
            <option value="" disabled>Select User</option>
            {getUsersData.map((item) => (
              <option key={item.User_Id} value={item.User_Id}>
                {item.User_Name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className='row mt-5'>
        <div className='col-12'>
          <Select
            isMulti
            options={outletOptions}
            value={selectedOutlets}
            onChange={setSelectedOutlets}
            placeholder="Select Outlets"
            className="basic-multi-select"
            classNamePrefix="select"
          />
        </div>
      </div>

      <div className='row mt-5'>
        <div className='col-4'>
          <button className='btn btn-primary' onClick={upsertUserOutletData}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOutletToUser;
